import React from "react";

import { useTranslation } from "react-i18next";

import { Container, Image, Text } from "./styles";

export default function EmptySection() {
  const { t: translate } = useTranslation();

  return (
    <Container>
      <Image
        // eslint-disable-next-line global-require
        src={require("../../../../../../../assets/img/heavy-box/amico.png")}
        alt="heavy-boxes"
      />
      <Text>{translate("nothingToShowHereYet")}</Text>
    </Container>
  );
}
